<style lang="scss" src='./ReviewOrderModal.scss' scoped></style>
<template src="./ReviewOrderModal.html"></template>

<script>
  import {
    mapState,
    mapActions,
    mapMutations
  } from "vuex";

  import StarsRaiting from '@/components/starsRaiting/StarsRaiting'
  export default {
    name: 'ReviewOrderModal',
    components:{
      StarsRaiting
    },
    data() {
      return {
        showModal: false,
        review:{
          orderId: null,
          comment : null,
          stars: 5,
        },
        orderInfo: null,
      };
    },
    computed: {
      ...mapState(['loading'])
    },

    methods: {
      ...mapActions(['fnApiUpdateOrderReview']),

      fnResetModal() {
        this.showModal = false;
        this.review = {
          orderId: null,
          comment : null,
          stars: 5,
        }
        this.orderInfo = null;
        this.loading.review = false;
      },

      async fnValidate() {
        if (await this.$refs['reviewOrderForm'].validate()) {
          this.review.orderId = this.orderInfo._id;
          await this.fnApiUpdateOrderReview([this.review, () => {this.fnResetModal()}]);
        }
      },
    },

    beforeCreate() {},
    created() {},
    mounted() {},
    beforeDestroy() {},
  };

</script>
